// extracted by mini-css-extract-plugin
export default {"layer":"VendorStoreModal_layer__wZHQ1","popup":"VendorStoreModal_popup__UpgXS","cancel":"VendorStoreModal_cancel__Yc5k0"};